const schema = localStorage.getItem("schema");
const userDetails = JSON.parse(localStorage.getItem("authUser"));

export const basicFormData = () => ({
  inputData: {
    issue_qty: null,
    issued_by: userDetails?.id,
    issued_at: new Date().toISOString().replace("T", " ").slice(0, 19),
    job_card_no: null,
    spare_part: null,
    quantity: null,
    requested_by: null,
    requested_at: null,
    status: null,
    is_active: true,
  },
});

export const createPageData = () => {
  const payload = {
    modelName: "spare_part_issues",
    schema: schema,

    include: [
      {
        model: "spare_part_requests",
        as: "request",
      },
      {
        model: "user_masters",
        as: "issued_by_user",
      },
    ],
  };

  const headerName = "Material Approval";

  const validationType = "SparePartIssues";
  const createEndpoint = "/updaterelationaldata  ";
  const updateEndpoint = "/updaterelationaldata  ";
  const getEndpoint = "/getRecords";

  return {
    payload,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  };
};
